import React from 'react';
import { useResponsive } from '../../../hooks/useResponsive';
import { IUser } from '../../../types/types';

interface BankInfoSectionProps {
  user: IUser;
  activeSection: string;
}

const BankInfoSection: React.FC<BankInfoSectionProps> = ({ user, activeSection }) => {
  const { isMobile } = useResponsive()

  return (
    <section className={`bottom ${isMobile && activeSection !== 'bank' ? 'hidden-mobile' : ''}`}>
      <h6 className="dashBoardTitle">اطلاعات بانکی</h6>
      <div className={`bank-info-container ${isMobile ? 'mobile-bank-info' : ''}`}>
        <div className="bank-info-row">
          <label className="sideBarTitle">شماره کارت</label>
          <input
            className="editProductInput"
            defaultValue={user?.cardNumber}
            name="cardNumber"
            placeholder="1234-5678-9012-3456"
            maxLength={19}
          />
        </div>

        <div className="bank-info-row">
          <label className="sideBarTitle">شماره حساب</label>
          <input
            className="editProductInput"
            defaultValue={user?.hesabNumber}
            name="hesabNumber"
            placeholder="شماره حساب"
          />
        </div>

        <div className="bank-info-row">
          <label className="sideBarTitle">شماره شبا</label>
          <input
            className="editProductInput"
            defaultValue={user?.shebaNumber}
            name="shebaNumber"
            placeholder="IR123456789012345678901234"
            maxLength={26}
          />
        </div>

        <div className="bank-info-row">
          <label className="sideBarTitle">نام بانک</label>
          <input
            className="editProductInput"
            defaultValue={user?.bankName}
            name="bankName"
            placeholder="نام بانک"
          />
        </div>
      </div>
    </section>
  );
};

export default BankInfoSection;
